<template>
  <validation-provider :rules="validations" v-slot="{ errors }">
    <v-text-field
      :value="value"
      :label="field.label"
      :disabled="readonly"
      @change="onChange"
      :error-messages="errors"
      v-mask="mask"
      :outlined="outlined"
      color="#005c7b"
    ></v-text-field>
  </validation-provider>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  props: ["field", "value", "readonly", "outlined", "validations"],
  directives: { mask },
  data() {
    return {
      mask: "######",
    };
  },
  methods: {
    onChange(event) {
      this.$emit("fieldChange", Number(event));
    },
  },
};
</script>
